import { useEffect, useState } from 'react';
import { MessageCircle, X, CheckCircle2 } from 'lucide-react';
import { RECEIPTS_EVENT } from '../lib/khataQueue';
import { receiptWaUrl } from '../lib/khataReceipt';
import { fmtStamp } from './LiveClock';

export default function KhataReceiptsDialog() {
  const [items, setItems] = useState([]);
  const [sent, setSent] = useState({});

  useEffect(() => {
    const on = (e) => { if (e.detail?.length) { setItems(e.detail); setSent({}); } };
    window.addEventListener(RECEIPTS_EVENT, on);
    return () => window.removeEventListener(RECEIPTS_EVENT, on);
  }, []);

  if (!items.length) return null;
  return (
    <div data-testid="khata-receipts-dialog" className="fixed inset-0 z-[70] bg-black/50 flex items-end md:items-center justify-center" onClick={() => setItems([])}>
      <div className="bg-white w-full md:max-w-md rounded-t-3xl md:rounded-3xl p-5 max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2">
          <CheckCircle2 className="w-5 h-5 text-[#1B5E20]"/>
          <div className="font-heading font-black text-lg">Synced — send receipts</div>
          <button data-testid="khata-receipts-close" onClick={() => setItems([])} className="ml-auto text-ink/40 hover:text-ink" aria-label="Close"><X className="w-5 h-5"/></button>
        </div>
        <p className="text-xs text-ink/60 mt-1">Your offline entries are saved. Tap to send each customer a WhatsApp receipt.</p>
        <ul className="mt-3 space-y-2">
          {items.map(({ row, recordedAt }, i) => (
            <li key={row.id || i} data-testid={`khata-receipt-${i}`} className="rounded-xl border-2 border-ink/10 p-3 flex items-center gap-3">
              <div className="flex-1 min-w-0">
                <div className="font-bold text-sm truncate">{row.customer_name || row.customer_phone}</div>
                <div className="text-[11px] text-ink/60">{row.type === 'debit' ? 'Udhaar' : 'Paid'} ₹{row.amount} · {fmtStamp(recordedAt || row.created_at)}</div>
                <div className="font-mono text-[10px] text-ink/50">{row.txn_serial}</div>
              </div>
              <a data-testid={`khata-receipt-send-${i}`} href={receiptWaUrl(row, { recordedAt })} target="_blank" rel="noreferrer"
                onClick={() => setSent((s) => ({ ...s, [i]: true }))}
                className={`pill text-xs ${sent[i] ? '!bg-white !text-[#1B5E20]' : '!bg-[#25D366] !text-white !border-[#25D366]'}`}>
                <MessageCircle className="w-3.5 h-3.5"/>{sent[i] ? 'Sent' : 'Send'}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
